import { assetPermissionChecker, PermissionMatrixName, PermissionName } from "@netx/core-permissions-next/utils";
import type { IAsset } from "../schema";
import { currentUserMeetsUserLevel, UserLevel } from "@netx/core-user-next/utils/currentUserMeetsUserLevel";

export const canRemoveAssetFromCategory = (asset?: IAsset): boolean => {
    if (!asset) return false;
    if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
    return (asset.categories ?? []).length > 1 && assetPermissionChecker({
        asset,
        permissionMatrixName: PermissionMatrixName.MODIFY,
        permissionName: PermissionName.ORGANIZE
    })
}
